import PostForm from '../../Social/PostForm';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { Alert, Button, Divider, Stack, Typography } from '@mui/material';
import useCourse from '../Hooks/useCourse';
import Posts from "../../Social/Posts";
import { txt } from '../../../services/translation';

export default function Post({ section }){

    const [submit, setSubmit] = useState(false)

    const data = useCourse()

    const navigate = useNavigate()

    const {course, tab} = useParams()

    const backLink = `/study/${course}/${tab}`;


    return <div className="study-post">

        {!submit && <>
            
            <PostForm
                embed={true}
                section={tab}
                courseId={course}
                sectionId={section?.id ?? null}
                type={'question'}
                onSubmit={() => setSubmit(true)}
                onClose={() => navigate(backLink)}
            />

            <Divider sx={{mt: 6}}/>

            <Typography variant='h5' sx={{my: 3}}>{txt('questionsAboutCourse')}</Typography>

            <Posts 
                filter='posts'
                tag={data.tag}
                courseId={course}
                search=''
                onTagClick={() => null}
            />

        </>}

        {submit && <Stack direction='column' alignItems='center' spacing={2}>

            <Alert severity='success'>{txt('postPublishedSuccess')}</Alert>

            <Link to={backLink}>
                <Button>{txt('backToCourse')}</Button>
            </Link>

        </Stack>}

    </div>
}